export function NotUndefined<T>(x: T | undefined): x is T {
  return x !== undefined;
}
